import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';

import { ShareButtonsModule } from '@ngx-share/buttons';

import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';

import { SortPipe } from './pipes/sort.pipe';
import { HeaderComponent } from './components/header/header.component';
import { JourneySelectionComponent } from './components/journey-selection/journey-selection.component';
import { JourneyOptionsComponent } from './components/journey-options/journey-options.component';
import { FooterComponent } from './components/footer/footer.component';
import { JourneyWeeksComponent } from './components/journey-weeks/journey-weeks.component';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslateService } from './services/translate.service';
import { CardJourneyComponent } from './components/journey-weeks/card-journey/card-journey.component';

@NgModule({
  declarations: [
    AppComponent,
    SortPipe,
    HeaderComponent,
    JourneySelectionComponent,
    JourneyOptionsComponent,
    FooterComponent,
    JourneyWeeksComponent,
    TranslatePipe,
    CardJourneyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    MatGridListModule,
    MatCardModule,
    MatGoogleMapsAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    ShareButtonsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAqfCDSFjJ9hu8YTEU3jxqFpS-XMXb3IM4',
      libraries: [
        'places',
        'geometry'
      ]
    }),
    AgmDirectionModule,
    HttpClientModule,
    FontAwesomeModule,
  ],
  exports: [
    MatGoogleMapsAutocompleteModule,
    MatCardModule,
    MatGoogleMapsAutocompleteModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    ShareButtonsModule,
    TranslatePipe
  ],
  providers: [
    DecimalPipe,
    SortPipe,
    TranslatePipe,
    TranslateService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(faLibrary: FaIconLibrary) {
    faLibrary.addIconPacks(fas, fab, far, fal, fad);
  }
}
